var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBalanceMultiplier = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10719_86000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.55572 3.88954C9.99216 3.88954 12.7779 3.0936 12.7779 2.11176C12.7779 1.12992 9.99216 0.333984 6.55572 0.333984C3.11928 0.333984 0.333496 1.12992 0.333496 2.11176C0.333496 3.0936 3.11928 3.88954 6.55572 3.88954Z",
    fill: "#00A1B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55572 7.88957C9.99216 7.88957 12.7779 7.09401 12.7779 6.11179V4.09668C10.8188 5.14646 7.44816 5.2229 6.55572 5.2229C5.66327 5.2229 2.29261 5.14646 0.333496 4.09668V6.11179C0.333496 7.09401 3.11927 7.88957 6.55572 7.88957Z",
    fill: "#00A1B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77794 17.1071V19.7649C8.0935 19.8449 7.33794 19.8893 6.55572 19.8893C3.11572 19.8893 0.333496 19.0893 0.333496 18.1115V16.0938C2.28905 17.1426 5.66683 17.2226 6.55572 17.2226C6.93794 17.2226 7.78238 17.2049 8.77794 17.1071Z",
    fill: "#00A1B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87572 13.0982C8.84905 13.1782 8.83127 13.276 8.8135 13.3649L8.77794 13.3382V15.7649C8.0935 15.8449 7.33794 15.8893 6.55572 15.8893C3.11572 15.8893 0.333496 15.0893 0.333496 14.1115V12.0938C2.28905 13.1426 5.66683 13.2226 6.55572 13.2226C6.94683 13.2226 7.83572 13.2049 8.87572 13.0982Z",
    fill: "#00A1B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55572 9.2229C5.66327 9.2229 2.29261 9.14646 0.333496 8.09668V10.1118C0.333496 11.094 3.11927 11.8896 6.55572 11.8896C9.99216 11.8896 12.7779 11.094 12.7779 10.1118V8.09668C10.8188 9.14646 7.44816 9.2229 6.55572 9.2229Z",
    fill: "#00A1B3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10719_86000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2051 15.8875L15.6472 13.7948H16.627V12.478H14.6127L13.5154 14.265L13.3194 14.5942C13.2777 14.6569 13.2489 14.7118 13.2332 14.7589H13.2097C13.1941 14.6961 13.1654 14.6412 13.1235 14.5942C13.0137 14.3956 12.9536 14.2859 12.9432 14.265L11.8538 12.478H9.69057V13.7948H10.7643L12.2143 15.9267L10.6703 18.2075H9.66699V19.5164H11.6892L12.904 17.557C12.9824 17.4315 13.0477 17.3166 13.1 17.2122L13.1705 17.0476H13.1941C13.2097 17.1102 13.2385 17.1651 13.2803 17.2122L13.4684 17.5413L14.7147 19.5164H16.6586V18.2075H15.8039L14.2051 15.8875Z",
    fill: "#00A1B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6793 19.9085V20.5358H18.8612C18.8821 20.332 18.9892 20.1413 19.1825 19.9637C19.3759 19.786 19.6033 19.6214 19.8644 19.4699C20.1254 19.3183 20.3856 19.1551 20.6442 18.98C20.9028 18.805 21.1223 18.5803 21.3027 18.3058C21.4829 18.0314 21.5732 17.7221 21.5732 17.3772C21.5732 16.8598 21.3953 16.4458 21.0401 16.1349C20.685 15.8239 20.2199 15.6685 19.645 15.6685C19.0808 15.6685 18.5894 15.8384 18.1717 16.178C17.9782 16.3295 17.8136 16.5019 17.6777 16.6952L18.5009 17.4163C18.6159 17.2752 18.7098 17.1758 18.7831 17.1185C19.0236 16.9145 19.2769 16.8126 19.5433 16.8126C19.7575 16.8126 19.9417 16.8766 20.0959 17.0046C20.25 17.1327 20.3268 17.296 20.3268 17.4945C20.3268 17.6669 20.259 17.8341 20.1232 17.9963C19.9875 18.1583 19.8175 18.2991 19.6136 18.4194C19.41 18.5395 19.1905 18.6819 18.9552 18.8464C18.7202 19.011 18.5006 19.1809 18.2967 19.3558C18.0932 19.5308 17.9232 19.7569 17.7874 20.0339C17.6515 20.3109 17.5835 20.6165 17.5835 20.9508C17.5835 20.9562 17.5914 21.0764 17.607 21.3114L17.6383 21.5228H21.667V19.9085H20.6793Z",
    fill: "#00A1B3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10719_86000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "white",
    transform: "translate(0.333496 0.333984)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10719_86000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(9.66699 11.0005)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBalanceMultiplier);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_balance_multiplier.f0d0697db43243b87b25f8ad745fd4c4.svg";